import React, { useEffect, useState } from "react";
// import axios from "axios";
import api from "../api";
import { Bar, Pie, Doughnut } from "react-chartjs-2";
import { Chart, CategoryScale, LinearScale, BarElement, ArcElement, Tooltip, Legend } from "chart.js";
Chart.register(CategoryScale, LinearScale, BarElement, ArcElement, Tooltip, Legend);


const AdminDashboard = () => {
  const apiUrl = process.env.REACT_APP_API_ENDPOINT;
  const [pesertaEvent, setPesertaEvent] = useState([]);
  const [pesertaCategory, setPesertaCategory] = useState([]);
  const [akomodasi, setAkomodasi] = useState({ ya: 0, tidak: 0 });
  const [pembayaran, setPembayaran] = useState({ APPROVED: 0, PENDING: 0, REJECTED: 0 });

  useEffect(() => {
    api.get(`${apiUrl}/api/admin/dashboard/peserta-per-event`).then(res => setPesertaEvent(res.data));
    api.get(`${apiUrl}/api/admin/dashboard/peserta-per-category`).then(res => setPesertaCategory(res.data));
    api.get(`${apiUrl}/api/admin/dashboard/peserta-akomodasi`).then(res => setAkomodasi(res.data));
    api.get(`${apiUrl}/api/admin/dashboard/pembayaran-status`).then(res => setPembayaran(res.data));
  }, [apiUrl]);

  return (
    <div className="container-xl mt-4">
      <h2 className="mb-4">Admin Dashboard</h2>
      <div className="row g-4">
        <div className="col-md-6">
          <div className="card card-body">
            <h4>Peserta per Event</h4>
            <Bar
              data={{
                labels: pesertaEvent.map(e => e.event),
                datasets: [{
                  label: "Jumlah Peserta",
                  data: pesertaEvent.map(e => e.jumlah),
                  backgroundColor: "#206bc4"
                }]
              }}
              options={{ responsive: true, plugins: { legend: { display: false } } }}
            />
          </div>
        </div>
        <div className="col-md-6">
          <div className="card card-body">
            <h4>Peserta per Audience Category</h4>
            <Bar
              data={{
                labels: pesertaCategory.map(e => e.category),
                datasets: [{
                  label: "Jumlah Peserta",
                  data: pesertaCategory.map(e => e.jumlah),
                  backgroundColor: "#2fb344"
                }]
              }}
              options={{ responsive: true, plugins: { legend: { display: false } } }}
            />
          </div>
        </div>
        <div className="col-md-6">
          <div className="card card-body">
            <h4>Peserta Akomodasi Hotel</h4>
            <Pie
              data={{
                labels: ["Ya", "Tidak"],
                datasets: [{
                  data: [akomodasi.ya, akomodasi.tidak],
                  backgroundColor: ["#206bc4", "#f76707"]
                }]
              }}
              options={{ responsive: true }}
            />
          </div>
        </div>
        <div className="col-md-6">
          <div className="card card-body">
            <h4>Status Pembayaran Peserta</h4>
            <Doughnut
              data={{
                labels: ["APPROVED", "PENDING", "REJECTED"],
                datasets: [{
                  data: [pembayaran.APPROVED, pembayaran.PENDING, pembayaran.REJECTED],
                  backgroundColor: ["#2fb344", "#f76707", "#fa5252"]
                }]
              }}
              options={{ responsive: true }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;